import { Translation, QRType } from '../types';

export const zhTw: Translation = {
  nav: {
    generator: '產生器',
    scanner: '掃描器',
    mobile: '手機體驗',
    blog: '部落格',
    langSelect: '選擇語言',
  },
  pageTitles: {
    generator: '免費線上 QR Code 產生器',
    scanner: '線上 QR Code 掃描器',
    textToQr: '文字轉 QR Code',
    linkToQr: '連結轉 QR Code',
  },
  pageMeta: {
    generator: {
      title: '免費 QR Code 產生器 — 線上建立 QR Code（無註冊、無浮水印、PNG/SVG/PDF）| YesQRCode',
      description:
        '使用 YesQRCode 免費線上建立 QR Code。支援網址、文字、WiFi、名片等，下載高品質 PNG、SVG 或 PDF。無需帳號、無浮水印，快速、安全、永久免費。',
      keywords: ['QRCode 產生器', '免費 QRCode', '線上製作 QR Code', 'QRCode PNG', 'QRCode SVG', 'QRCode PDF', 'WiFi QRCode', '名片 QRCode', '免註冊 QRCode', 'Logo QRCode'],
    },
    scanner: {
      title: '線上 QR Code 掃描器 — 圖片/相機掃碼（安全、免註冊）| YesQRCode',
      description:
        '免費線上掃描 QR Code 與條碼。上傳圖片或直接使用相機。本地解碼、不上傳檔案。安全、快速、無需註冊，完全免費。',
      keywords: ['QRCode 掃描', '線上掃碼', '網頁掃碼', '圖片掃碼', '線上掃條碼', '安全掃碼', '離線掃碼', '免費 QR 掃描器', '瀏覽器掃碼', '免註冊掃碼'],
    },
    textToQr: {
      title: '文字轉 QR Code | 將筆記即時生成可分享的 QR',
      description: '把文字、留言或提示一鍵生成可分享的 QR Code。自訂品牌樣式，立即下載 PNG、SVG 或 PDF，無需註冊。',
      keywords: ['文字轉 QRCode', '文字 QR 產生', '留言 QRCode', '筆記 QRCode', '線上文字 QR', '免費文字 QR'],
    },
    linkToQr: {
      title: '連結轉 QR Code | 將網址快速生成 QR',
      description: '貼上任何網址，立即生成可列印或數位使用的品牌化 QR Code。支援自訂顏色、Logo、高解析度下載。',
      keywords: ['連結轉 QRCode', '網址 QRCode', '網站 QRCode', 'UTM QRCode', 'QRCode 下載 PDF', '線上產生網址 QR'],
    },
  },
  hero: {
    title: '建立隱私、安全又符合品牌的 QR Code —— 永久免費。',
    subtitle: '快速、重視隱私且彈性的 QR 工具，適合任何流程。',
    desc: '不需帳號、無浮水印、無資料上傳，就能產生與掃描高品質 QR Code。',
    ctaPrimary: '產生 QR Code',
    ctaSecondary: '手機體驗',
  },
  info: {
    helpTitle: '說明中心',
    helpSubtitle: '常見問題與支援',
    contactTitle: '聯絡我們',
    contactSubtitle: '期待收到你的訊息。',
    privacyTitle: '隱私政策',
    termsTitle: '服務條款',
  },
  contactForm: {
    name: '姓名',
    email: '電子郵件',
    message: '留言',
    send: '送出',
    orEmail: '或直接來信',
    sending: '傳送中...',
    successTitle: '已送出！',
    successMessage: '感謝你的留言，我們將盡快回覆。',
    sendAnother: '再發一則',
    errorMessage: '暫時無法送出，請改以 support@yesqrcode.com 聯絡我們。',
  },
  generator: {
    highlights: {
      title: '建立隱私、安全又符合品牌的 QR Code —— 永久免費。',
      subtitle: '快速、重視隱私且彈性的 QR 工具，適合任何流程。',
      items: [
        { title: '隱私優先，本機產生', desc: 'QR Code 於裝置本地生成 —— 無上傳、無追蹤、無儲存。' },
        { title: '涵蓋所有情境', desc: '網址、WiFi、名片、條碼、Logo、漸層、邊框通通內建。' },
        { title: '行動優化體驗', desc: '針對手機與觸控優化，製作與掃描都順手。' },
        { title: '永久免費，可商用', desc: '無需帳號、無浮水印、無掃描上限 —— 團隊與品牌都安心。' },
      ],
    },
    featureSuite: {
      title: '以隱私為核心的完整 QR 套件',
      subtitle: '在同一處建立乾淨、具品牌感且高品質的 QR Code。',
      categories: [
        { title: '完整類型支援', body: 'URL、文字、WiFi、郵件、電話、SMS、vCard、社群連結、YouTube、條碼。靜態碼永不過期。', items: [] },
        { title: '品牌與設計', body: 'Logo 友善、漸層、邊框、形狀、圓角，兼顧美感與可掃性。', items: [] },
        { title: '輸出與品質', body: '高解析度 PNG、SVG、PDF，提供印刷與數位場景的預設。', items: [] },
        { title: '全球與易用性', body: '多語介面、行動優先、支援離線流程。', items: [] },
      ],
    },
    trust: {
      title: '創作者與品牌都在使用',
      subtitle: '輕量、可預期、無帳號、無綁定，適合長期活動與安全場景。',
      items: ['零上手成本', '靜態碼穩定可用', '企業安全：無雲端處理', '跨素材保持一致品牌'],
    },
    sectionContent: '內容',
    sectionColors: '顏色',
    sectionLogo: 'Logo',
    sectionFrame: '邊框',
    sectionDesign: '樣式',
    sectionCorrection: '容錯率',
    labelUrl: '網站連結',
    labelText: '純文字',
    labelSsid: '網路名稱（SSID）',
    labelPassword: '密碼',
    labelEncryption: '加密方式',
    labelFgColor: '前景色',
    labelBgColor: '背景色',
    labelFrameText: '邊框文字',
    labelFrameColor: '邊框顏色',
    placeholder: '在此輸入內容...',
    placeholders: {
      url: 'https://example.com',
      text: '請輸入文字',
      email: 'your@email.com',
      subject: '主旨',
      message: '你的留言...',
      phone: '+886 912 345 678',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: '下載 PNG',
    downloadSvg: '下載 SVG',
    generateButton: '產生 QR Code',
    copy: '複製 SVG',
    uploadLogo: '上傳圖片',
    preview: '預覽',
    lowQuality: '低畫質',
    highQuality: '高畫質',
    foreverFree: '永久免費 • 免註冊 • 可商用',
    barcodeWarning: '條碼不支援邊框與 Logo 等進階樣式。',
    barcodeColors: '你仍可在下方自訂顏色。',
    frameStyles: {
      none: '無',
      simple: '簡潔',
      balloon: '氣泡',
      box: '方框',
      badge: '徽章',
      polaroid: '拍立得',
      phone: '手機框',
      header: '抬頭',
      corner: '圓角',
    },
    vCard: {
      firstName: '名',
      lastName: '姓',
      mobile: '手機',
      phone: '電話',
      fax: '傳真',
      email: '電子郵件',
      company: '公司',
      job: '職稱',
      street: '街道',
      city: '城市',
      zip: '郵遞區號',
      state: '州/省',
      country: '國家',
      website: '網站',
    },
    types: {
      [QRType.URL]: '網址',
      [QRType.TEXT]: '文字',
      [QRType.EMAIL]: '郵件',
      [QRType.PHONE]: '電話',
      [QRType.SMS]: '簡訊',
      [QRType.WIFI]: 'WiFi',
      [QRType.VCARD]: '名片',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: '條碼',
    },
    guide: {
      title: '如何建立自訂 QR Code？',
      steps: [],
    },
    gettingStarted: {
      title: '使用步驟',
      steps: [
        {
          title: '設定 QR 內容',
          text: '選擇上方的內容類型（網址、文字、郵件等），填寫掃碼後要顯示的資訊。印刷後內容無法修改，請確認正確性。',
        },
        {
          title: '自訂設計',
          text: '想要獨特外觀？設定品牌色，調整角點與主體形狀，加入 Logo 或使用漸層與邊框。',
        },
        {
          title: '產生 QR Code',
          text: '利用滑桿調整像素解析度，點擊「下載」保存。印刷前請先掃描預覽，確認可讀性。',
        },
        {
          title: '下載圖片',
          text: '可下載 .png、.svg 或 .pdf。若需要完整設計的向量格式，請選擇 .svg；Logo 與設計目前支援 .png 與 .svg。',
        },
      ],
    },
    about: {
      title: '免費且隱私優先的 QR Code 套件',
      subtitle: '無需帳號、無浮水印、無資料上傳即可產生/掃描高品質 QR Code，適合印刷、品牌與商業用途。',
      features: ['熱門類型全支援：網址、文字、WiFi、名片、簡訊、條碼', '最高 30% 容錯率，Logo 安全', '自訂形狀、漸層、顏色、邊框', '靜態 QR Code 永久有效', '多語介面，全球團隊適用'],
      content: [
        { title: 'Logo 友善的 QR Code', body: '加入 Logo 仍可確保掃描成功，最高 30% 容錯率，適合包裝、菜單與指示牌。' },
        { title: '可調整的形狀與邊框', body: '更換角點形狀、套用漸層，選擇符合活動的邊框；設計與可掃性並重。' },
        { title: '多種內容型態', body: '同一介面產生網址、文字、WiFi、名片、簡訊、條碼，並提供對應模板。' },
        { title: '靜態碼長期可用', body: '建立永不過期的靜態 QR Code，長期活動與印刷物料都可靠。' },
      ],
    },
    faq: {
      title: '常見問題',
      items: [
        { q: '什麼是 QR Code？', a: 'QR 是 Quick Response 的縮寫，由日本 Denso Wave 在 1994 年發明的二維條碼。' },
        { q: '產生的 QR Code 可以商用嗎？', a: '可以，本產生器建立的 QR Code 免費且可自由使用。' },
        { q: 'QR Code 會過期嗎？', a: '不會。YesQRCode 產生的是靜態碼，不會失效，但內容無法再編輯。' },
        { q: '掃描次數有限制嗎？', a: '沒有上限，可以不限次掃描。' },
        { q: 'YesQRCode 會儲存我的資料嗎？', a: '不會。我們不會保存或重複使用你的資料。為提升效能，圖片會在伺服器快取 24 小時。' },
        { q: '為何名片 QR 的欄位不完整？', a: '部分掃碼 App 未遵循 vCard 標準，可能導致欄位錯置，建議改用其他掃描器。' },
        {
          q: 'QR Code 無法掃描怎麼辦？',
          a: '請先檢查輸入是否有錯。部分類型（如名片）資料量大，可適當減少。嘗試移除 Logo，並確保前景與背景對比足夠，前景顏色應更深。',
        },
        { q: 'YesQRCode 支援哪些瀏覽器？', a: '需支援 HTML5 的現代瀏覽器，官方兼容 Chrome、Firefox、Safari、Edge 與 IE11。' },
      ],
    },
  },
  scanner: {
    title: '掃描 QR 與條碼',
    subtitle: '使用相機、上傳圖片或貼上截圖，即刻解碼。',
    cameraPermission: '相機權限被拒絕，請在瀏覽器設定中開啟。',
    result: '結果',
    copy: '複製',
    copied: '已複製',
    open: '開啟連結',
    delete: '刪除',
    scanAgain: '再掃一個',
    privacy: '全部於瀏覽器本地處理，檔案不會離開你的裝置。',
    upload: '上傳圖片',
    paste: '貼上 (Ctrl+V)',
    drop: '拖曳圖片到此',
    retry: '重試',
    errorAccessDenied: '相機權限被拒絕',
    errorCamera: '請在瀏覽器設定中允許相機存取。',
    initializing: '正在啟動相機...',
    cameraActive: '相機已啟動',
    scannedItems: '已掃描內容',
    recentScans: '最近記錄（僅本機）',
    clickToUpload: '點擊上傳',
    newBadge: '新',
    tabCameraMobile: '相機',
    tabCameraDesktop: '相機掃描',
    emptyState: {
      title: '尚無記錄',
      desc: '上傳圖片或切換到相機開始掃描。',
    },
    highlights: {
      title: '快速且重視隱私的掃描體驗',
      items: [
        { title: '本機解碼', desc: '預設不會上傳，適合敏感連結與素材。' },
        { title: '多格式支援', desc: '支援 QR、UPC/EAN、Code 128、ITF 等。' },
        { title: '快速操作', desc: '拖曳、貼上或立即切換相機。' },
        { title: '行動端友善', desc: '針對手機 UI 與相機流程優化。' },
      ],
    },
    intro: {
      title: '線上 QR 與條碼掃描器',
      body: '直接在瀏覽器解碼 QR Code、UPC、EAN 等，無需安裝 App。',
    },
    howTo: {
      title: '如何掃描？',
      methods: [
        { title: '方式一：上傳', steps: ['點擊「上傳圖片」', '選擇 QR/條碼', '立即獲得結果'] },
        { title: '方式二：相機', steps: ['開啟「相機」分頁', '授予權限', '對準 QR/條碼'] },
      ],
    },
    features: {
      title: '為何使用這裡？',
      items: [
        { title: '本機歷史', desc: '最近掃描僅儲存在本機，可隨時複製或再次開啟。' },
        { title: '離線圖片解碼', desc: '上傳或貼上圖片即使離線也能解碼；相機掃描需支援的瀏覽器與權限。' },
        { title: '快捷操作', desc: '複製、開啟或刪除結果一鍵完成。' },
      ],
    },
    useCases: {
      title: '常見用途',
      items: [
        { title: '零售/購物', desc: '查看商品連結、優惠券或說明。' },
        { title: '倉儲團隊', desc: '核對條碼、處理庫存更新。' },
        { title: '日常使用者', desc: '快速開啟菜單、Wi-Fi 連結或聯絡人。' },
      ],
    },
    faq: {
      title: '掃描常見問題',
      items: [
        { q: '可以掃條碼嗎？', a: '可以，支援 QR 以及 Code 128、UPC、EAN、ITF 等。' },
        { q: '會儲存我的掃描紀錄嗎？', a: '不會，所有資料都留在你的瀏覽器本機。' },
        { q: '可以貼上截圖嗎？', a: '可以，按 Ctrl+V（或 Cmd+V）直接貼上。' },
        { q: '離線可以用嗎？', a: '上傳/貼上圖片可離線解碼；相機掃描需要權限與相容的瀏覽器。' },
      ],
    },
  },
  blog: {
    title: '洞察與指南',
    subtitle: '關於 QR 體驗的最佳做法、行銷點子與產品更新。',
    readMore: '閱讀全文',
    back: '返回部落格',
    notFound: '找不到文章',
  },
  common: {
    footer: '為行銷人、設計師與團隊打造的強大 QR 工具套件。',
    privacy: '隱私',
    terms: '條款',
    contact: '聯絡',
    scanToOpen: '掃碼在手機開啟',
    help: '說明',
    free: '免費',
    product: '產品',
    resources: '資源',
    company: '公司',
    api: 'API（即將推出）',
    systemStatus: '系統正常',
    footerDesc: '先進的 QR Code 產生與掃描工具。快速、重視隱私，個人與商業用途皆免費。',
  },
};
